import withSession from "grandus-lib/utils/session";
import DefaultPage, {
  getServerSideProps as defaultServerSideProps,
} from "grandus-lib/pages/auth/signup.default";

export const getServerSideProps = withSession(async ({ req, res }) => {
  return defaultServerSideProps({ req, res });
});

export default DefaultPage;
